import styled from "styled-components";
import { Dialog } from "@mui/material";

export const DialogStyle = styled(Dialog)`
  top: 0%;
  .dds-columns-modal {
    height: 600px;
    overflow: scroll;
  }
`;

export const DialogFooterStyles = styled.div`
  border-radius: 0px 0px 4px 4px;
  /* background-color: #fafbfc; */
  padding: 0 20px;
  z-index: 10;
  .footer {
    display: flex;
    flex-direction: row-reverse;
    gap: 20px;
    padding: 10px 0px;
    border-top: 1px solid #dedafb;
  }
`;
